export default "__VITE_ASSET__BtG6$Pry__"